<template>
  <div class="myFooter layout_footer layout_parent"
    v-if="$store.state.myRender.common.footer_display === 'true'"
    :style="{
      backgroundColor: f_b[f_b.radio_val].color,
      backgroundImage: f_b[f_b.radio_val].img !== '' ? `url(${f_b[f_b.radio_val].img})` : 'none',
      backgroundSize: f_b[f_b.radio_val].background_size,
      backgroundRepeat: f_b[f_b.radio_val].background_repeat,
      backgroundPosition: f_b[f_b.radio_val].background_position,
    }"
  >
    <layout_row
      v-for="(val,i) in $store.state.myRender.footer"
      :row="val"
      :row_index="i"
      :key="val.widgets_id"
       v-show="$store.state.app.view_pattern == 'mb' ? val.data.mb_infor.isShow ? true : $store.state.mb_row_isShow.row_btn_isShow : true"
    >
    </layout_row>
  </div>
</template>

<script>
  import layout_row from '@/widgets/layout_row/index.vue';
  export default {
    name: 'myFooter',
    components:{
      layout_row
    },
    computed:{
      f_b () {
        return this.$store.state.myRender.common.footer_background
      },
    },
    data () {
      return {
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/public/footer.vue